import React, { FunctionComponent } from 'react';
import { InternalLink } from '../internal-link/internal-link';
import styles from './dropdown-link.module.scss';

interface IDropDownLinkChildren {
  name: string;
  url: string;
  isActive?: boolean;
}
export interface IDropDownLinkProps extends React.PropsWithChildren<{}> {
  name: string;
  isActive?: boolean;
  children: IDropDownLinkChildren[];
  colorWhite: boolean;
}

export const DropDownLink: FunctionComponent<IDropDownLinkProps> = props => {
  const { name, isActive, children, colorWhite } = props;
  return (
    <div className={styles.dropDownContainer}>
      <div
        className={`
          ${isActive ? styles.dropDownHeaderActive : styles.dropDownHeader}
          ${colorWhite && styles.white}`}
      >
        {name}
        <i className="material-icons" style={{ color: '#e64510' }}>
          keyboard_arrow_down
        </i>
      </div>
      <div
        className={
          isActive ? styles.dropDownContentActive : styles.dropDownContent
        }
      >
        <ul className={styles.dropDownList}>
          {children.map((item, p) => (
            <li key={p}>
              <InternalLink
                url={item.url}
                className={
                  item.isActive
                    ? styles.dropDownLinkActive
                    : styles.dropDownLink
                }
              >
                {item.name}
              </InternalLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
